import { __assign } from 'tslib';

var table = {
    base: {
        font: "body",
        fontSize: 2,
        textAlign: "left",
    },
};
var tableBody = {
    base: {},
};
var tableCellData = {
    base: {
        alignItems: "center",
        flexWrap: "wrap",
        gap: 2,
        py: 2,
        px: 3,
        boxSizing: "border-box",
    },
};
var tableCellHead = {
    base: __assign(__assign({}, tableCellData.base), { fontSize: 1, fontWeight: "body", color: "black.80", alignItems: "flex-end" }),
};
var tableHead = {
    base: {
        mb: 3,
        "[data-table-row]": {
            borderColor: "transparent",
            borderRadius: 0,
            ":hover, &[data-is-hover=true]": {
                boxShadow: "none",
            },
        },
    },
};
var tableRow = {
    base: {
        border: "1px solid",
        borderRadius: 3,
        mt: 3,
        px: 3,
        minHeight: "56px",
        boxSizing: "border-box",
        borderColor: "black.5",
        transition: "box-shadow ease-in-out, border-color ease-in-out",
        transitionDuration: 5,
        background: "white",
        ":hover, &[data-is-hover=true]": {
            boxShadow: 3,
        },
        "&[data-is-open=true], &[data-is-animating=true]": {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        },
        "&[data-selected=true]": {
            borderColor: "primary.100",
        },
        ":first-of-type": {
            mt: 0,
        },
        "+[data-table-row-disclosure]": {
            p: 0,
            borderBottomLeftRadius: 3,
            borderBottomRightRadius: 3,
            transition: "box-shadow ease-in-out",
            transitionDuration: 5,
            ":hover, &[data-is-hover=true]": {
                boxShadow: 3,
            },
            "[data-table-cell-disclosure]": {
                p: 0,
            },
            "[data-table-cell-disclosure-box]": {
                background: "white",
                minHeight: "56px",
                boxSizing: "border-box",
                border: "1px solid",
                borderTop: "none",
                borderBottomLeftRadius: 3,
                borderBottomRightRadius: 3,
                borderColor: "black.5",
            },
        },
    },
};

export { table, tableBody, tableCellData, tableCellHead, tableHead, tableRow };
//# sourceMappingURL=table.js.map
